// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { constants } from "@ces/XDL/constants";
import { xBaseTheme } from "@ces/XDL/types";
import { color } from "@ces/XDL/Utilities";
import { hideElementOnPrint } from "@ces/XDL/Utilities/sharedStyles";
import xScreen from "@ces/XDL/Utilities/xScreen";
import DrawerPresentationPropsDefault from "@insite/mobius/Drawer/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DrawerPresentationPropsDefault,
        cssOverrides: {
            scrim: css`
                ${xScreen("lte", "md")} {
                    top: ${constants.header.tablet.size.height + 1}px;
                }
                ${xScreen("lte", "sm")} {
                    top: ${constants.header.mobile.size.height + 1}px;
                }
                ${hideElementOnPrint}
            `,
            drawerTitle: css`
                display: none;
            `,
            drawerContent: css`
                overflow-x: hidden;
                height: 100%;
            `,
            drawerBody: css`
                box-shadow: none;
                ${xScreen("lte", "md")} {
                    top: ${constants.header.tablet.size.height + 1}px;
                    width: 360px;
                }
                ${xScreen("lte", "xs")} {
                    top: ${constants.header.mobile.size.height + 1}px;
                    width: 100%;
                }
                background: ${color("common.ui1")};
            `,
        },
    },
} as xBaseTheme["drawer"];
